import PaymentError from './PaymentError';

export default PaymentError;
